export default __webpack_public_path__ + "f4bca41224961991f166e6a842c54e2d.png";